import React from 'react'
import { useInsightContentData } from 'hooks/useInsightModalState'
import { InsightContentSettingType } from 'components/insightContent/types'
import { CountTypeStrings } from 'enums/CountType'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import Overview from 'components/insightContent/visualization/Overview'
import { useTranslation } from 'react-i18next'
import RunSearchEffect from './RunSearchEffect'

const TrendingTotalMeasure = ({
  detailSetting,
  countType
}: {
  detailSetting: InsightContentSettingType
  countType: CountTypeStrings
}) => {
  const insightContent = useInsightContentData(InsightContentType.TRENDING_TOTAL_MEASURE)
  const { t } = useTranslation()

  return (
    <UnexpectedErrorBoundary>
      <RunSearchEffect detailSetting={detailSetting} countType={countType}>
        <Overview
          title={t('total_posts')}
          displayTitleTooltip={detailSetting.displayTitleTooltip}
          count={
            insightContent?.data?.[0]?.results?.[0]?.data?.metrics?.[0]?.dataset?.[0]?.set?.[0]
          }
          status={insightContent?.status}
        />
      </RunSearchEffect>
    </UnexpectedErrorBoundary>
  )
}
export default TrendingTotalMeasure
